module.exports = __webpack_public_path__ + "static/media/materialui.53c8f867.svg";